import classNames from 'classnames';
import React from 'react';
import { SubPanelContainer } from '@/components/sub-panel-container';
import { useLocaleStore } from '@/i18n';
import { type WidgetCommonProps } from '../../types';
import {
    BackgroundInspector,
    FillInspector,
    GlowInspector,
    ShadowInspector,
    StrokeInspector,
    TextEffectEntry,
} from '../../widgets';
import './style.less';

type Props = {
    type: string | null;
    free?: boolean;
    hidePresets?: boolean;
    onExit: () => void;
} & WidgetCommonProps;

const INSPECTORS = [
    { type: 'stroke', Component: StrokeInspector },
    { type: 'shadow', Component: ShadowInspector },
    { type: 'glow', Component: GlowInspector },
    { type: 'background', Component: BackgroundInspector },
] as const;

export const TextEffectPanel: React.FC<Props> = ({
    type,
    free = false,
    hidePresets = false,
    onExit,
    ...commonProps
}) => {
    const { $t } = useLocaleStore();

    const { isIntl } = commonProps;

    const shouldShowInspector = (inspectorType: string) => {
        return type === inspectorType || !type;
    };

    return (
        <SubPanelContainer title={$t((v) => v.panel.textPanel.textEffect)} onExit={onExit}>
            {!type && (
                <TextEffectEntry
                    {...commonProps}
                    free={free}
                    hidePresets={hidePresets}
                    showDetailBtn={false}
                    style={{ padding: '0 16px' }}
                />
            )}
            <div
                className={classNames('text-effect-panel', { 'text-effect-panel--intl': isIntl })}
                style={{ marginTop: type ? -16 : 0 }}
            >
                <div className="text-effect-panel__inspector">
                    {!type && (
                        <>
                            <FillInspector {...commonProps} />
                            <div className="text-effect-panel__divider" />
                        </>
                    )}

                    {INSPECTORS.map(
                        ({ type: inspectorType, Component }, index) =>
                            shouldShowInspector(inspectorType) && (
                                <React.Fragment key={inspectorType}>
                                    <Component {...commonProps} />
                                    {index < INSPECTORS.length - 1 && <div className="text-effect-panel__divider" />}
                                </React.Fragment>
                            ),
                    )}
                </div>
            </div>
        </SubPanelContainer>
    );
};
